function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BAD8E6",
  d: "M14.727 0H1.637C.733 0 0 .701 0 1.563v2.345h16.364V1.563C16.364.701 15.63 0 14.727 0zM0 12.505c0 .862.734 1.563 1.636 1.563h13.091c.903 0 1.637-.7 1.637-1.563v-5.47H0v5.47zM2.455 9.38h4.909v1.563h-4.91V9.38z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F4F7",
  fillRule: "nonzero",
  d: "M1.636 4.689H18V12.504999999999999H1.636z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#009FE4",
  d: "M16.364 1.563H3.273c-.903 0-1.637.701-1.637 1.563v2.345H18V3.126c0-.862-.734-1.563-1.636-1.563zM1.636 14.068c0 .863.734 1.564 1.637 1.564h13.09c.903 0 1.637-.701 1.637-1.564v-5.47H1.636v5.47zm2.455-3.126H9v1.563H4.09v-1.563z"
}));

function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.97e41167.svg";
export { ForwardRef as ReactComponent };